import { CircularProgress } from '@mui/material'
import { CheckCircleOutlineOutlined, ErrorOutlineOutlined } from '@mui/icons-material'

import { Body2, Caption, Group, Stack } from '@collaborate-health/uikit'
import { CertificateScopeTypeDisplayName } from '@tabeeb/modules/certificates/enums'
import { QualificationCertificateTypeResponse } from '@tabeeb/contracts/microservices/swagger-certificate-service'

export interface QualificationCertificateTypeCardProps {
  loading: boolean
  approved: boolean
  certificateType: QualificationCertificateTypeResponse
}

const QualificationCertificateTypeCard: React.FC<QualificationCertificateTypeCardProps> = ({
  loading,
  certificateType,
  approved,
}) => {
  return (
    <Group key={certificateType.Id}>
      <Stack direction='row' gap={1}>
        <Stack gap={0.5} flex={1} overflow='hidden'>
          <Body2 title={certificateType.Name} noWrap>
            {certificateType.Name}
          </Body2>
          <Caption noWrap>Category: {certificateType.CategoryName}</Caption>
          <Caption noWrap>Scope: {CertificateScopeTypeDisplayName[certificateType.ScopeId]}</Caption>
        </Stack>

        {loading ? (
          <CircularProgress size={15} />
        ) : approved ? (
          <CheckCircleOutlineOutlined color='success' />
        ) : (
          <ErrorOutlineOutlined color='error' />
        )}
      </Stack>
    </Group>
  )
}

export default QualificationCertificateTypeCard

